<bw-action-article-legacy
  [maxWidth]="'600px'"
  [brightsideWebFb]="{ event_name: 'autosave_intro' }">
  <div pre-title class="mb-sm">
    <img src="../assets/money-stack.png">
  </div>
  <div content-section>
    <typography-legacy
      text-small-regular color="var(--secondary-text)"
      class="mb-sm"
    >
      {{ 'POST_SAVINGS_TITLE' | translate }}</typography-legacy>
    <typography-legacy title-medium class="mb-sm">
      {{ 'POST_SAVINGS_SUB_TITLE' | translate  }}
    </typography-legacy>
    <typography-legacy
      text-small-regular color="var(--secondary-text)"
      class="mb-sm">
      {{ 'POST_SAVINGS_CONTENT_ONE_SUB_TITLE' | translate }}
    </typography-legacy>
    <bw-bui-tile-legacy tileMargin="0 0 8px 0" class="mb-sm">
      <bui-tile-card-legacy  cardBackground="var(--green-5)">
        <bw-bui-row-legacy rightIconName="lock" rightIconColor="green">
          <div class="row-content">
            <bw-bui-column-legacy [rowSpacing]="4" [rows]="[
            {type: 'heading', content: 'POST_SAVINGS_CONTENT_TWO_TITLE' | translate, color: 'black'},
            {type: 'paragraph', content: 'POST_SAVINGS_CONTENT_TWO_SUB_TITLE' | translate, color: 'var(--secondary-text)'}
            ]"></bw-bui-column-legacy>
          </div>
        </bw-bui-row-legacy>
      </bui-tile-card-legacy>
    </bw-bui-tile-legacy>
  </div>
  <div footer-actions class="flex-row row-reverse">

    <button
      bw-button-legacy
      type="submit"
      [brightsideWebFb]="{ event_name: 'autosave_intro'}"
      (click)="goToAutoSave()">
      {{ 'POST_SAVINGS_CTA1' | translate }}
    </button>
    <button
      bw-link-button-legacy
      [brightsideWebFb]="{ event_name: 'autosave_intro_secondary'}"
      (click)="goToDashboard()">
      {{'POST_SAVINGS_CTA2'|translate}}
    </button>
  </div>

</bw-action-article-legacy>
